import {AfterViewInit, Component, OnDestroy, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {RSDialogComponentModel} from '../../../libs/rsnotify/rsdialog.component.model';
import {AssistanceProvidedType, ExtensionCategory, PracticeChangeActivity} from '../../../../functions/src/types';
import {RSDialog} from '../../../libs/rsnotify/rsdialog';
import {UserService} from "../../services/user.service";
import {RSValidatorFormDirective} from "../../../libs/rsvalidator/rsvalidator.directive";
import {DataService} from "../../services/data.service";
import invert from "invert-color";
import {ReplaySubject} from "rxjs";
import {map} from "rxjs/operators";

@Component({
  selector: 'app-add-practice-change-activity',
  templateUrl: './add-practice-change-activity.component.html',
  styleUrls: ['./add-practice-change-activity.component.scss']
})
export class AddPracticeChangeActivityComponent extends RSDialogComponentModel implements OnInit, AfterViewInit, OnDestroy {
  practiceChange: PracticeChangeActivity = {} as PracticeChangeActivity;
  @ViewChild('actionButtons', {static: true, read: TemplateRef}) actionButtons: TemplateRef<any>;
  @ViewChild('form') inputForm: RSValidatorFormDirective;

  filteredCategories = new ReplaySubject<ExtensionCategory[]>(1);


  constructor(private userService: UserService, public dataService: DataService) {
    super();

    // Wait for input
    this.dialogValuesUpdated.subscribe(v => {
      this.updatePracticeChangeActivity(v.practiceChange);
    });
    this.updatePracticeChangeActivity({});
  }

  invertColor(hex) {
    return invert(hex || '#ffffff', true);
  }

  ngOnInit(): void {
    this.dataService.categories.pipe(
      map(categories => {
        // Get all non-archived categories
        const activeCategories = categories.filter(cat => !cat.archived);

        // If we have a selected category that's archived, add it to the list
        if (this.practiceChange.category) {
          const selectedCategory = categories.find(cat =>
            cat.id === this.practiceChange.category && cat.archived);
          if (selectedCategory) {
            activeCategories.push(selectedCategory);
          }
        }

        return activeCategories;
      })
    ).subscribe(filtered => {
      this.filteredCategories.next(filtered);
    });

  }

  ngOnDestroy() {
    this.filteredCategories.complete();
  }

  ngAfterViewInit(): void {
    this.dialogHandles.buttonTemplateRef = this.actionButtons;
    this.dialogHandles.buttonTemplateAttach();
  }

  updatePracticeChangeActivity(input: any) {
    this.practiceChange = {
      id: input.id || null,
      name: input.name || null,
      category: input.category || null
    } as PracticeChangeActivity;
    console.log('AddPracticeChangeActivity::: ', this.practiceChange);
  }

  close() {
    this.dialogHandles.close(RSDialog.defaultValues.CANCEL);
  }

  savePracticeChangeActivity() {
    if (!this.inputForm.isValid(true)) {
      return;
    } else {
      this.dialogValues.practiceChange = this.practiceChange;
      this.dialogHandles.close(RSDialog.defaultValues.YES);
    }
  }

}
